import {DatePicker as ArkDatePicker} from '@ark-ui/react/date-picker'
import {Portal as ArkPortal} from '@ark-ui/react'
import {fromArkDatePickerContextValues} from '~/components/date_based_pickers/helpers'
import {EitjeButton, Layout} from '~/components'
import './index.less'

/**
 * @typedef {Object} DatePickerPickerRootProps
 * @property {import('react').ReactNode} children
 * @property {(context: import('~/components/date_based_pickers/helpers').DatePickerContextValues) => import('react').ReactNode} [renderExtraFooter]
 * @property {boolean} [showTodayFooter]
 */

/** @param {DatePickerPickerRootProps} props */
export const DatePickerPickerRoot = ({children, showTodayFooter, renderExtraFooter}) => {
	// Keep Escape inside the open picker so it does not also close a parent modal.
	// It's needed here specifically because when the picker is closed, Ark shifts focus back to its trigger.
	// If this is handled at the root, it would block the event and therefore prevent the parent modal to close.
	const handleKeyDown = event => {
		if (event.key === 'Escape') event.stopPropagation()
	}

	return (
		<ArkPortal>
			<ArkDatePicker.Positioner>
				<ArkDatePicker.Content onKeyDown={handleKeyDown}>
					<Layout padding="6">{children}</Layout>
					{(showTodayFooter || renderExtraFooter) && (
						<ArkDatePicker.Context>
							{ctx => (
								<Layout data-part="footer" direction="vertical" padding="8" borderTop>
									{showTodayFooter && (
										<EitjeButton
											height="small"
											t="common.today"
											onClick={() => {
												ctx.selectToday()
												ctx.setOpen(false)
											}}
										/>
									)}
									{renderExtraFooter?.(fromArkDatePickerContextValues(ctx))}
								</Layout>
							)}
						</ArkDatePicker.Context>
					)}
				</ArkDatePicker.Content>
			</ArkDatePicker.Positioner>
		</ArkPortal>
	)
}
